// @flow
import React from 'react';
import { Form, Input } from 'semantic-ui-react';
import LoginUtil from './LoginUtil';
import ThemeUtils from "shared/utils/ThemeUtils";

type Props = {
  password: string,
  isSigningIn: boolean,
  onChange: (evt: SyntheticEvent<Input>, data: { value: string }) => void,
  inputRef: (?HTMLInputElement) => void
};

const LoginPasswordField = (props) => (
    <Form.Field>
        <label style={{ color: '#1FA637' }}>Password</label>
        <Input
            ref={props.inputRef}
            type="password"
            value={props.password}
            disabled={props.isSigningIn}
            onChange={props.onChange}
            autoComplete="current-password"
        />
    </Form.Field>
);

export default LoginPasswordField; 